const renderAddress = (fileData) => {
    let address = '';
    address = fileData.number_street ? fileData.number_street : '';
    address += fileData.city !== '' ? ',\n' + fileData.city : '';
    address += fileData.country !== '' ? ',\n' + fileData.country : '';
    address += fileData.postal_code !== '' ? ',\n' + fileData.postal_code : '';
    return address;
}

export { renderAddress };